//import { createApp } from 'vue'
import { createApp } from 'vue/dist/vue.esm-bundler';
import App from './App.vue'
import router from './router'

import store from "./store";

import AlertWarning from "@/components/views/layout/AlertWarning.vue";
import AlertDanger from "@/components/views/layout/AlertDanger.vue";

import BadgeDefault from "@/components/views/layout/BadgeDefault.vue";
import DangerBadge from "@/components/views/layout/DangerBadge.vue";
import SuccessBadge from "@/components/views/layout/SuccessBadge.vue";
import WarningBadge from "@/components/views/layout/WarningBadge.vue";
import InfoBadge from "@/components/views/layout/InfoBadge.vue";

import DateForm from "@/components/views/layout/forms/DateForm.vue"
import SwitchForm from "@/components/views/layout/forms/SwitchForm.vue"
import { DatePicker } from "v-calendar";
import GoBackLink from "@/components/views/layout/GoBackLink.vue";
import LoadingMessage from "@/components/views/layout/LoadingMessage.vue";
import SelectForm from "@/components/views/layout/forms/SelectForm.vue";
import TabsContainer from "@/components/views/layout/TabsContainer.vue";
import BreadCrumbs from "@/components/views/layout/BreadCrumbs.vue";
import vSelect from "vue-select";
import RadioForm from "@/components/views/layout/forms/RadioForm.vue";
import YesNoLabel from "@/components/views/layout/forms/YesNoLabel.vue";

import SuccessButton from "@/components/views/layout/forms/SuccessButton.vue";
import SuccessButtonProcessing from "@/components/views/layout/forms/SuccessButtonProcessing.vue";
import MainButton from "@/components/views/layout/forms/MainButton.vue";
import MainButtonProcessing from "@/components/views/layout/forms/MainButtonProcessing.vue";
import NewButton from "@/components/views/layout/forms/NewButton.vue";
import EditButton from "@/components/views/layout/forms/EditButton.vue";
import DestroyButton from "@/components/views/layout/forms/DestroyButton.vue";
import DestroyButtonProcessing from "@/components/views/layout/forms/DestroyButtonProcessing.vue";
import WhiteButton from "@/components/views/layout/forms/WhiteButton.vue";
import InfoButton from "@/components/views/layout/forms/InfoButton.vue";
import DangerButton from "@/components/views/layout/forms/DangerButton.vue";
import UploadButton from "@/components/views/layout/forms/UploadButton.vue";
import GrayButton from "@/components/views/layout/forms/GrayButton.vue";

import "@/assets/styles/tailwind.css";
import "@/assets/styles/fontawesome.all.min.css";

import 'v-calendar/dist/style.css';
import 'vue-select/dist/vue-select.css';

import '@/assets/styles/buttons.css';
import '@/assets/styles/exportation-status.css';
import "@/assets/styles/container-status.css";
import '@/assets/styles/forms.css';
import "@/assets/styles/layout.css";
import "@/assets/styles/login.css";
import "@/assets/styles/panels.css";
import '@/assets/styles/vue-select.css'



import  { i18n } from "@/locales/index.js";

import app_notifications_mixin from './components/views/mixins/app_notifications.js';
import authentication_mixin from "./components/security/mixins/authentication.js";
import authorization_mixin from './components/security/mixins/authorization.js';
import user_mixin from "./components/security/mixins/user.js";
import formatters_mixin from "./components/views/mixins/formatters.js";
import layout_mixin from "./components/views/mixins/layout.js";
import standard_error_messages_mixin from './components/views/mixins/standard_error_messages.js';
import secure_code_generator_mixin from './components/security/mixins/secure_code_generator.js'
import module_name_mixin from './components/views/mixins/module_routes.js'
import download_files_mixin from './components/views/mixins/download_files';

//createApp(App).use(router).use(i18n).mount('#app');

const app = createApp(App);

app.use(router);
app.use(i18n);
app.use(store);
app.component("alert-warning", AlertWarning);
app.component("alert-danger", AlertDanger);

app.component("badge-default", BadgeDefault);
app.component("danger-badge", DangerBadge);
app.component("success-badge", SuccessBadge);
app.component("warning-badge", WarningBadge);
app.component("info-badge", InfoBadge);

app.component("date-form", DateForm);
app.component("switch-form", SwitchForm);
app.component("radio-form", RadioForm);
app.component("yes-no-label", YesNoLabel);
app.component("go-back-link", GoBackLink);
app.component("loading-message", LoadingMessage);
app.component("select-form", SelectForm);
app.component("v-select", vSelect);
app.component("v-datepicker", DatePicker);
app.component("tabs-container", TabsContainer);
app.component("bread-crumbs", BreadCrumbs);
app.component("main-button", MainButton);
app.component("main-button-processing", MainButtonProcessing);
app.component("new-button", NewButton);
app.component("success-button", SuccessButton);
app.component("success-button-processing", SuccessButtonProcessing);
app.component("edit-button", EditButton);
app.component("destroy-button", DestroyButton);
app.component("destroy-button-processing", DestroyButtonProcessing);
app.component("white-button", WhiteButton);
app.component("danger-button", DangerButton);
app.component("upload-button", UploadButton);
app.component("info-button", InfoButton);
app.component("gray-button", GrayButton);

app.mixin(app_notifications_mixin);
app.mixin(authentication_mixin);
app.mixin(authorization_mixin);
app.mixin(user_mixin);
app.mixin(formatters_mixin);
app.mixin(layout_mixin);
app.mixin(standard_error_messages_mixin);
app.mixin(secure_code_generator_mixin);
app.mixin(module_name_mixin);
app.mixin(download_files_mixin);
app.mount('#app');
